




























import Vue from 'vue'
export default Vue.extend({
  name: 'MailboxSettingsSavedRepliesReply',

  props: {
    index: {
      type: Number,
      default: 0,
    },
    id: {
      type: Number,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    edit(): void {
      this.$emit('edit', this.index)
    },
    remove(): void {
      this.$emit('remove', this.index)
    },
  },
})
